<template>
    <div class="flex border border-xp-light-grey rounded-sm overflow-hidden">
        <div class="w-full lg:w-[451px] flex-shrink-0">
            <div
                v-if="offices.length || distributors.length"
                class=""
            >
                <form id="offices-filters" class="p-7">
                    <select
                        v-model="selected_country"
                        id="offices-country-select"
                        class="border-xp-carbon rounded-sm w-full text-black tracking-huge uppercase font-bold"
                    >
                        <option :value="null">Worldwide</option>
                        <option v-for="(country, i) in countries" v-bind:key="i">
                            {{ country }}
                        </option>
                    </select>
                    <div class="mt-4 flex flex-wrap gap-4">
                        <div class="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="filter-offices"
                                v-model="show.offices"
                            />
                            <label for="filter-offices"> Our Offices </label>
                        </div>
                        <div class="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="filter-distributors"
                                name="filter_distributors"
                                v-model="show.distributors"
                            />
                            <label for="filter-distributors">
                                Distribution Partners
                            </label>
                        </div>
                    </div>
                </form>
                <div
                    ref="list"
                    id="offices-list"
                    class="lg:h-[560px] lg:overflow-y-auto border-t border-xp-line-grey"
                >
                    <div
                        v-show="show.offices && (office.all_countries.includes(selected_country) || !selected_country)"
                        v-for="office in offices"
                        v-bind:key="office.id"
                        @click.stop="highlightOnMap(office.id)"
                        :id="'location-' + office.id"
                        :class="
                            selected_id === office.id &&
                            'bg-xp-light-grey'
                        "
                        class="flex items-end justify-between px-7 border-t border-xp-line-grey first-of-type:border-transparent cursor-pointer"
                    >
                        <div class="py-[13px]">
                            <h3
                                v-if="office.title"
                                class="text-sm font-black tracking-wide text-black"
                            >
                                {{ office.title }}
                            </h3>
                            <!-- <p
                                v-if="office.company_name"
                                class="text-black tracking-wide text-sm mt-1"
                            >
                                {{ office.company_name }}
                            </p> -->
                            <div
                                class="font-normal text-black tracking-wide text-sm"
                            >
                                <span v-if="office.address_1" class="offices__address-1">
                                    {{ office.address_1 }},
                                </span>
                                <span v-if="office.address_2">
                                    {{ office.address_2 }},
                                </span>
                                <span v-if="office.address_3">
                                    {{ office.address_3 }},
                                </span>
                                <span v-if="office.town">
                                    {{ office.town }},
                                </span>
                                <span v-if="office.city">
                                    {{ office.city }},
                                </span>
                                <span v-if="office.county">
                                    {{ office.county }},
                                </span>
                                <span v-if="office.postcode">
                                    {{ office.postcode }},
                                </span>
                                <span v-if="office.country">
                                    {{ office.country }}
                                </span>
                            </div>
                            <div
                                v-if="office.tel"
                                class="mt-1"
                            >
                                <a
                                    class="text-sm text-xp-lilac font-normal underline underline-offset-2"
                                    :class="
                                        selected_id === office.id &&
                                        'background-color-primary text-color-white'
                                    "
                                    :href="'tel:' + office.tel"
                                    target="_blank"
                                >
                                    {{ office.tel }}
                                </a>
                            </div>
                        </div>
                        <div class="py-[18px]">
                            <svg class="shrink-0 text-black group-hover:translate-x-1 transition-transform group-hover:text-black" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" /><path d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" /></svg>
                        </div>
                    </div>
                    <div
                        v-show="
                            show.distributors &&
                            (selected_country === distributor.country ||
                                !selected_country)
                        "
                        v-for="distributor in distributors"
                        v-bind:key="distributor.id"
                        @click.stop="highlightOnMap(distributor.id)"
                        :id="'location-' + distributor.id"
                        :class="
                            selected_id === distributor.id &&
                            'bg-xp-light-grey'
                        "
                        class="flex items-end justify-between px-7 border-t border-xp-line-grey first-of-type:border-transparent cursor-pointer"
                    >
                        <div class="py-[13px]">
                            <h3
                                v-if="distributor.title"
                                class="text-sm font-black tracking-wide text-black"
                            >
                                {{ distributor.title }}
                            </h3>
                            <!-- <p
                                v-if="distributor.company_name"
                                class="text-black tracking-wide text-sm mt-1"
                            >
                                {{ distributor.company_name }}
                            </p> -->
                            <div
                                class="text-black font-normal tracking-wide text-sm"
                            >
                                <span v-if="distributor.address_1">
                                    {{ distributor.address_1 }},
                                </span>
                                <span v-if="distributor.address_2">
                                    {{ distributor.address_2 }},
                                </span>
                                <span v-if="distributor.address_3">
                                    {{ distributor.address_3 }},
                                </span>
                                <span v-if="distributor.town">
                                    {{ distributor.town }},
                                </span>
                                <span v-if="distributor.city">
                                    {{ distributor.city }},
                                </span>
                                <span v-if="distributor.county">
                                    {{ distributor.county }},
                                </span>
                                <span
                                    v-if="distributor.postcode"
                                    class="offices__postcode"
                                >
                                    {{ distributor.postcode }},
                                </span>
                                <span v-if="distributor.country">
                                    {{ distributor.country }}
                                </span>
                            </div>
                            <div class="mt-1">
                                <a
                                    v-if="distributor.tel"
                                    class="text-sm text-xp-lilac font-normal underline underline-offset-2"
                                    :class="
                                        selected_id === distributor.id &&
                                        'background-color-primary text-color-white'
                                    "
                                    :href="'tel:' + distributor.tel"
                                    target="_blank"
                                >
                                    {{ distributor.tel }}
                                </a>

                                <span v-if="distributor.url" class="mx-2">
                                    |
                                </span>
                                <a
                                    v-if="distributor.url"
                                    class="text-sm text-xp-lilac font-normal underline underline-offset-2"
                                    :class="
                                        selected_id === distributor.id &&
                                        'background-color-primary text-color-white'
                                    "
                                    :href="distributor.url"
                                    target="_blank"
                                >
                                    View website
                                </a>
                            </div>
                        </div>
                        <div class="py-[18px]">
                            <svg class="shrink-0 text-black group-hover:translate-x-1 transition-transform group-hover:text-black" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" /><path d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" /></svg>
                        </div>
                    </div>
                </div>
            </div>
            <h4 v-else>No offices and distributors added yet!</h4>
        </div>
        <div class="flex-1 hidden lg:block" ref="google-map"></div>
    </div>
</template>
<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
    props: {
        mapConfig: {
            type: Object,
            required: true,
        },
        officeLocations: {
            type: Array,
            required: false,
            default: () => [],
        },
        distributorLocations: {
            type: Array,
            required: false,
            default: () => [],
        },
        offices: {
            type: Array,
            required: false,
            default: () => [],
        },
        distributors: {
            type: Array,
            required: false,
            default: () => [],
        },
        countries: {
            type: Array,
            required: false,
            default: () => [],
        },
        officeMarkerImageUrl: {
            type: String,
            required: false,
        },
        distributorMarkerImageUrl: {
            type: String,
            required: false,
        },
    },
    data: () => ({
        google: null,
        map: null,
        office_markers: null,
        distributor_markers: null,
        show: {
            offices: true,
            distributors: true,
        },
        selected_country: null,
        selected_id: null,
        markers: [],
    }),
    async mounted() {
        await this.initialiseApi();
        this.initialiseMap();
        this.initialiseMarkers();
    },
    watch: {
        "show.offices"(new_val) {
            this.markers
                .filter((marker) => marker.is_office)
                .forEach((marker) => {
                    if (this.selected_country) {
                        if (marker.country === this.selected_country) {
                            marker.marker.setVisible(new_val);
                        }
                    } else {
                        marker.marker.setVisible(new_val);
                    }
                });
        },
        "show.distributors"(new_val) {
            this.markers
                .filter((marker) => !marker.is_office)
                .forEach((marker) => {
                    if (this.selected_country) {
                        if (marker.country === this.selected_country) {
                            marker.marker.setVisible(new_val);
                        }
                    } else {
                        marker.marker.setVisible(new_val);
                    }
                });
        },
        selected_country(new_val) {
            this.show.offices = true;
            this.show.distributors = true;

            if (!new_val) {
                this.markers.forEach((marker) => {
                    marker.marker.setVisible(true);
                });

                return;
            }

            this.markers
                .filter((marker) => marker.country === new_val)
                .forEach((marker) => {
                    marker.marker.setVisible(true);
                });

            this.markers
                .filter((marker) => marker.country !== new_val)
                .forEach((marker) => {
                    marker.marker.setVisible(false);
                });
        },
    },
    methods: {
        async initialiseApi() {
            const google_map_api = await GoogleMapsApiLoader({
                apiKey: process.env.MIX_GOOGLE_MAPS_KEY,
            });

            this.google = google_map_api;
        },
        initialiseMap() {
            this.map = new this.google.maps.Map(
                this.$refs["google-map"],
                this.mapConfig
            );
        },
        initialiseMarkers() {
            this.markers = this.officeLocations.map((office_location) => {
                const marker = new this.google.maps.Marker({
                    position: office_location.location,
                    map: this.map,
                    icon: this.officeMarkerImageUrl,
                });

                return {
                    id: office_location.id,
                    country: office_location.country,
                    marker,
                    is_office: true,
                };
            });

            const distributor_markers = this.distributorLocations.map(
                (distributor_location) => {
                    const marker = new this.google.maps.Marker({
                        position: distributor_location.location,
                        map: this.map,
                        icon: this.distributorMarkerImageUrl,
                    });

                    return {
                        id: distributor_location.id,
                        country: distributor_location.country,
                        marker,
                        is_office: false,
                    };
                }
            );

            (this.markers = this.markers.concat(distributor_markers)).forEach(
                (marker) => {
                    this.initialiseMarkerEvent(marker);
                }
            );
        },
        initialiseMarkerEvent(marker) {
            marker.marker.addListener("click", () => {
                this.selected_id = marker.id;

                this.map.setZoom(5);
                this.map.setCenter(marker.marker.getPosition());

                const element = document.getElementById(
                    "location-" + marker.id
                );

                this.$refs.list.scroll({
                    behavior: "smooth",
                    top: element.offsetTop - this.$refs.list.offsetTop,
                });

                marker.marker.setAnimation(this.google.maps.Animation.BOUNCE);

                setTimeout(function () {
                    marker.marker.setAnimation(null);
                }, 2000);
            });
        },
        highlightOnMap(id) {
            this.selected_id = id;

            const marker = this.markers.find((item) => item.id === id)?.marker;

            if (!marker) {
                return;
            }

            this.map.setZoom(5);

            this.map.setCenter(marker.getPosition());

            marker.setAnimation(this.google.maps.Animation.BOUNCE);

            setTimeout(function () {
                marker.setAnimation(null);
            }, 3000);
        },
    },
};
</script>

<style scoped type="text/css">
.selected_location {
    box-shadow: inset 0 0 10px 0 #5643A5;
}
</style>
